module.exports = __webpack_public_path__ + "img/google-play.c47f12e9.png";